import React, { useState } from 'react';
import Modal from 'molecules/Modal';
import { ButtonComp } from 'atoms/Buttons';
import ReorderIcon from 'styles/staticAssets/images/Reorder.svg';
import ReceiptComponent from './ReceiptComponent';
import OccassionComponent from './OccassionComponent';
import ORDER_HISTORY from '../Constants/Constants';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { getTrackOrderAnalytic } from '../../ReorderComponent/ReorderUtils/ReorderUtils';
import { useDispatch, useSelector } from 'react-redux';
import ReorderComponent from 'organisms/ReorderComponent/Container/ReorderComponent';
import { resetBasketAction } from '@kfc-global/react-shared/redux/Actions/CartAction';
import { getPostOrderAccepted } from '@kfc-global/react-shared/redux/Actions/PostOrderAction';
import { getReorderStoreStatus } from '@kfc-global/react-shared/redux/Actions/ReorderAction';
import { first, get } from 'lodash';
import { ChannelManager } from 'common/manager';
import { localisationStartAnalytics } from 'common/utilities/analyticsUtils';
import {
  getValueOrDefaultAlternativeObject,
  getValueOrDefaultObject,
  getTernaryValue,
  redirectToPaymentSuccessPage,
} from 'common/utilities/utils';
import {
  isDeliveryDistaOrderCancelled,
  isDeliveryDistaOrderDelivered,
  isDeliveryDistaOrderPolling,
  updatePostOrderDetails,
} from 'components/paymentProcessPage/Container/paymentProcessingFn';
import { CURRENT_FAV_MENU, LOCAL_STORAGE_KEYS } from 'common/constants/SharedConstants';
import { useHistory } from 'react-router-dom';

const ReOrderComponent = props => {
  const { isMobile, cardInfo, tenantData, customerId, orderItemArray, isGetOrdersLoading } = props;
  const orderItem = orderItemArray.find(order => order.id === cardInfo.id);
  const [showReceiptModal, setReceiptModalOpen] = useState(false);
  const [showOccassionModal, setOccassionModalOpen] = useState(false);
  const { REORDER_TEXT, ADD_TO_OCCASION, VIEW_RECEIPT, ACCOUNT_ORDERS, TRACK_ORDER } = ORDER_HISTORY;
  const cartReducer = useSelector(data => data.cartReducer);
  const tenantReducer = useSelector(data => data.tenantReducer);
  const [reorderModalOpen, setReorderModalOpen] = useState(false);
  const [isQuickReorderModalOpen, setQuickReorderModalOpen] = useState(false);
  const [storeInfo, setStoreInfo] = useState({});
  const { cartData = {} } = cartReducer;
  const { tenantId, currencyConversionFactor } = tenantReducer;
  const dispatch = useDispatch();
  const history = useHistory();
  const isOldOrder = () => new Date(orderItem?.fulfillmentDateTime * 1000).getTime() >= new Date().getTime();
  const userParams = useSelector(data => data.appStateReducer.userStatus);
  const receiptModalProps = {
    id: 'ReceiptModal',
    role: 'dialog',
    modalTitleId: 'ReceiptModal',
    show: showReceiptModal,
    classNames: 'Base-modal Receipt-modal',
    showCloseBtn: true,
    showBackBtn: false,
    closeButtonHandler: () => setReceiptModalOpen(false),
    modalTitle: 'ORDER RECEIPT',
    // backButtonHandler: handleClose,
    closeDataTestId: 'close-recipet-modal',
    autoFocus: true,
  };

  const receiptModalComponent = (
    <Modal {...receiptModalProps}>
      <div className='ReceiptModal'>
        <ReceiptComponent {...props} key={`receipt-${cardInfo.id}`} orderItem={orderItem} />
      </div>
    </Modal>
  );

  const occasionsModalProps = {
    id: 'OccassionModal',
    role: 'dialog',
    modalTitleId: 'OccassionModal',
    show: showOccassionModal,
    classNames: `Base-modal ${getTernaryValue(isMobile, 'Mobile-occassion-modal', 'Occassion-modal')}`,
    showCloseBtn: true,
    showBackBtn: false,
    closeButtonHandler: () => setOccassionModalOpen(false),
    modalTitle: '',
    modalTitleRequired: false,
    // backButtonHandler: handleClose,
    closeDataTestId: 'close-modal',
    autoFocus: true,
  };

  const occasionsModalComponent = (
    <Modal {...occasionsModalProps}>
      <div className='OccassionModal'>
        <OccassionComponent
          onCancel={() => setOccassionModalOpen(false)}
          cardInfo={cardInfo}
          tenantData={tenantData}
          customerId={customerId}
        />
      </div>
    </Modal>
  );

  const { foodLines = [] } = getValueOrDefaultObject(cartData);
  const successCallback = () => {
    if (foodLines.length > 0) {
      setReorderModalOpen(true);
    } else {
      dispatch(resetBasketAction());
      setQuickReorderModalOpen(true);
    }
  };

  const storeSuccessCallBack = response => {
    const storeDetails = first(get(response, 'response', {}), {});
    const { id: orderId } = getValueOrDefaultObject(orderItem);
    setStoreInfo(storeDetails);
    dispatch(getPostOrderAccepted({ tenantId, orderId, customerId }, successCallback));
  };

  const trackOrderBtnHandler = () => {
    const orderDetails = getValueOrDefaultObject(orderItem);
    sessionStorage.setItem(
      LOCAL_STORAGE_KEYS.ORDER_TRACKING,
      JSON.stringify(updatePostOrderDetails(tenantId, orderDetails)),
    );
    getTrackOrderAnalytic(orderDetails?.total / currencyConversionFactor);
    redirectToPaymentSuccessPage({ history });
  };

  const reorderBtnHandler = () => {
    if (isGetOrdersLoading) {return;}
    !userParams?.localized && localisationStartAnalytics();
    const { store = {}, service = '' } = getValueOrDefaultObject(orderItem);
    const { storeId = '' } = getValueOrDefaultObject(store);
    const data = [
      {
        storeId,
        channel: ChannelManager.channel,
        service,
      },
    ];
    dispatch(getReorderStoreStatus(data, tenantId, storeSuccessCallBack));
    /* setting true value to reorderClick, to avoid the toast onclick of reorder button */
    sessionStorage.setItem('reorderClick', true);
  };

  return (
    <>
      <div className='global-accordian-header-container mobile-accordian-reorder-container'>
        <span className='global-accordian-header mobile-accordian-header'>
          <span
            className={orderItem ? 'order-receipt-option' : 'order-receipt-Disable-option'}
            data-testid='view-receipt'
            onClick={() => setReceiptModalOpen(true)}
          >
            {translateWithI18Next(VIEW_RECEIPT)}
          </span>
          <span
            className='order-ocasion-option'
            data-testid='view-occasion-modal'
            onClick={() => setOccassionModalOpen(true)}
          >
            {translateWithI18Next(ADD_TO_OCCASION)}
          </span>
        </span>
        <div
          className={
            !isDeliveryDistaOrderCancelled(orderItem) && !isDeliveryDistaOrderDelivered(orderItem)
              ? `btn-algn global-accordian-right`
              : `global-accordian-right`
          }
        >
          {isDeliveryDistaOrderPolling(orderItem) && isOldOrder() && (
            <ButtonComp
              className='button re-order-btn redButton'
              aria-label={''}
              type='submit'
              onClickHandler={() => {
                trackOrderBtnHandler();
              }}
              data-testid='track-order-btn'
            >
              <img alt='account-icon' src={ReorderIcon} className='account-icon' />
              <span>{translateWithI18Next(TRACK_ORDER)}</span>
            </ButtonComp>
          )}

          <ButtonComp
            className='button re-order-btn redButton'
            aria-label={''}
            type='submit'
            onClickHandler={() => {
              reorderBtnHandler();
              localStorage.setItem(CURRENT_FAV_MENU, ACCOUNT_ORDERS);
            }}
            data-testid='re-order-btn'
          >
            <img alt='account-icon' src={ReorderIcon} className='account-icon' />
            <span>{translateWithI18Next(REORDER_TEXT)}</span>
          </ButtonComp>
        </div>
      </div>
      {showReceiptModal && orderItem && receiptModalComponent}
      {showOccassionModal && occasionsModalComponent}
      {getValueOrDefaultAlternativeObject(reorderModalOpen, isQuickReorderModalOpen) && (
        <ReorderComponent
          storeInfo={storeInfo}
          currentOrderInfo={cardInfo}
          reorderModalOpen={reorderModalOpen}
          setReorderModalOpen={setReorderModalOpen}
          isQuickReorderModalOpen={isQuickReorderModalOpen}
          setQuickReorderModalOpen={setQuickReorderModalOpen}
        />
      )}
    </>
  );
};

export default ReOrderComponent;
